import { DialogBackdrop, DialogPanel, Dialog as HeadlessDialog } from '@headlessui/react';
import classNames from 'classnames';
import { ReactNode } from 'react';

export type DialogProps = {
  children?: ReactNode,
  className?: string,
  height?: number,
  hide?: () => void,
  show?: boolean,
  width?: number
}

export const Dialog = ({ children, className, height=33, hide, show, width=20 }: DialogProps) => {

  const innerClasses = classNames(
    'bg-jw-blue text-white rounded-sm p-4 flex flex-col items-center justify-between',
    'relative overflow-auto min-h-0',
    className
  );

  const innerStyles = {
    height: `${height}vh`,
    width: `${width}vw`
  };

  return (
    <HeadlessDialog
      className='absolute top-0 left-0 bottom-0 right-0 z-50 flex items-center justify-center transition duration-100 ease-out data-[closed]:opacity-0'
      onClose={() => hide && hide()}
      open={show}
      transition
    >
      <DialogBackdrop
        className='fixed inset-0 bg-black/70 backdrop-blur-sm'
      />
      <DialogPanel
        className={innerClasses}
        style={innerStyles}
      >
        { children }
      </DialogPanel>

    </HeadlessDialog>
  );
};
